import React from "react";
import LeftImg from './images/services/recruitment-img.jpg'
import Icon01 from './images/services/recruitment-1.png'
import Icon02 from './images/services/recruitment-2.png'
import Icon03 from './images/services/recruitment-3.png'
import Icon04 from './images/services/recruitment-4.png'
import Icon05 from './images/services/recruitment-5.png'
import Icon06 from './images/services/recruitment-6.png'
import Icon07 from './images/services/recruitment-7.png'
import Icon08 from './images/services/recruitment-8.png'
function CustomerInfo() {
  return (
    <section className="image-description-section section" style={{alignItems:"start"}}>
        <p className="section-heading">HTI’s Recruitment Tool helps you easily manage your hiring and placement process end-to-end.</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description image-width"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
          Unlimited candidate profile management.</p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            AI-integrated resume reading system. </p>
        <p className="description-para">
            <img src={Icon06} width={30} height={30} className="img-fluid" alt="icons"/>
            Recruiter management dashboards & reports. </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            AI-integrated JD creation.</p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Managers' dashboards and reports.</p>
             <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Fast filters and search.</p>
    </div>
</section>  
  )
}
export default CustomerInfo;